module.exports = __webpack_public_path__ + "static/01-d6faf57bf22e3d94c7c04f6a5c5dbc24.jpg";